import { FooterContent } from "@/types/footer";
import { BannerItem } from "@/types/banner";

interface ServiceNode {
  slug: string;
  name: string;
}

interface StrapiFooterData {
  logo?: { src: string; alt: string } | null;
  columns?: { label: string; url: string; columnName?: string; opensInNewTab?: boolean }[];
  socialLinks?: { label: string; url: string; columnName?: string; opensInNewTab?: boolean }[];
  legalLinks?: { label: string; url: string; columnName?: string; opensInNewTab?: boolean }[];
  copyright?: string;
  contact?: {
    phone?: string;
    fax: string;
    address: string;
    officeHours: string;
    bookingLink?: string;
    billingPhone?: string;
    billingEmail?: string;
  };
}

interface StrapiHomePageContentNode {
  logoUrl: string;
  heroPrimaryButtonText: string;
  heroPrimaryButtonURL: string;
  navbarSecondaryCTA?: string;
  navbarSecondaryCTAUrl?: string;
}

interface StrapiBannerNode {
  id: string;
  text: string;
  linkText?: string;
  linkUrl?: string;
  sortOrder?: number;
}

export interface NavbarData {
  logoUrl: string;
  primaryCTA: string;
  primaryCTAUrl: string;
  navbarSecondaryCTA?: string;
  navbarSecondaryCTAUrl?: string;
  services: { slug: string; name: string; href: string }[];
  enableResources: boolean;
}

export const transformFooterData = (footerData: StrapiFooterData | null): FooterContent => ({
  logo: footerData?.logo || null,
  columns: footerData?.columns || [],
  socialLinks: footerData?.socialLinks || [],
  legalLinks: footerData?.legalLinks || [],
  copyright: footerData?.copyright || "",
  contact: footerData?.contact || {
    phone: "",
    fax: "",
    address: "",
    officeHours: "",
  },
});

export const transformNavbarData = (
  homePageContent: StrapiHomePageContentNode,
  serviceNodes: ServiceNode[],
  resourceCount: number
): NavbarData => ({
  logoUrl: homePageContent.logoUrl,
  primaryCTA: homePageContent.heroPrimaryButtonText,
  primaryCTAUrl: homePageContent.heroPrimaryButtonURL,
  navbarSecondaryCTA: homePageContent.navbarSecondaryCTA,
  navbarSecondaryCTAUrl: homePageContent.navbarSecondaryCTAUrl,
  services: serviceNodes.map(service => ({
    slug: service.slug,
    name: service.name,
    href: `/services/${service.slug}`,
  })),
  enableResources: resourceCount > 0,
});

export const transformBannerData = (bannerNodes: StrapiBannerNode[]): BannerItem[] =>
  bannerNodes.map(node => ({
    id: node.id,
    text: node.text,
    linkText: node.linkText,
    linkUrl: node.linkUrl,
    sortOrder: node.sortOrder,
  }));
